<a (click)="scrollToTop($event)" class="back-to-top" [@scrollAnimation]="state">
  <i class="fa fa-chevron-up"></i>
</a>